/**
 * Route for `finance-revenue-widget`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FinanceRevenueWidgetPage } from "../features/finance-revenue-widget/FinanceRevenueWidgetPage";

export const financeRevenueWidgetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/finance-revenue-widget",
	component: FinanceRevenueWidgetPage,
});

export default financeRevenueWidgetRoute;
